module.exports = __webpack_public_path__ + "a35a20863078b3dcf1473022d78d0f2d.png";